module.exports = __webpack_public_path__ + "media/images/latest-header-photo-978a76637c060dd4df0c98f725249556.jpg";